import React, { Fragment } from 'react';
import { Form, Select, Row, Col, Checkbox, Button, DatePicker, Input, AutoComplete, message, Radio } from 'antd';
import moment from 'moment';
import { CityComplete } from '~/components';
import { getCurrentLang, TripType, Languages, getTripType, combineUrl, config, animate, getValue4Lang } from '~/common';
import { FormattedMessage } from 'react-intl';
import { convertDate, formatDate } from '~/pages/PreTrip/helpers';
import { watch } from 'less';

const { Option } = Select;
class SearchForm extends React.Component {
    constructor(props) {
        super(props)
        const { searchParam, companyDataSource } = props
        this.state = {
            filterCompanyData: companyDataSource,
        }
    }

    renderOption = item => {
        return (
            <Option
                key={item.Id}
                text={item.DisplayName}
                className={`sg-option`}
            >{item.DisplayName}</Option>
        );
    }

    renderTravelOption = item => {
        return (
            <Option
                key={item.travelerId}
                text={item.travelerName}
                className={`sg-option`}
            >{item.travelerName}</Option>
        );
    }

    handleDateChange = (index, date) => {
        let param = this.props.searchParam;
        date && (param.multiFlights[index].depDate = date.format('YYYYMMDD'));
        for (let i = index + 1; i < param.multiFlights.length; i++) {
            let prevTrip = param.multiFlights[i - 1];
            let trip = param.multiFlights[i];
            if (!trip.depDate || moment(trip.depDate).isBefore(prevTrip.depDate)) {
                trip.depDate = moment(prevTrip.depDate).add(2, 'days').format('YYYYMMDD');
            }
        }
        this.props.handleSearchParamChange(param);
    }
    fm = (id, values) => this.props.intl.formatMessage({ id }, values);

    disabledDate = (fromDateText, date) => {
        if (fromDateText) {
            const fromDate = convertDate(fromDateText).startOf('days');
            date = date.startOf('days');
            const lastDate = convertDate(fromDateText).add(+1, 'years');
            return (date.isBefore(fromDate) || date.isAfter(lastDate));
        }
        return false;
    }


    componentWillMount() {
        const { searchParam, companyDataSource, handleSearchParamChange } = this.props;
        if (companyDataSource.length == 1) {
            searchParam.companyId = companyDataSource[0].Id;
            searchParam.companyName = companyDataSource[0].DisplayName;
            handleSearchParamChange(searchParam);
        }
        this.mounted = true;
    }
    render() {
        const { searchParam, handleSubmit, handleSearchParamChange, handleSearch, companyDataSource, travelDataSource, handleSearchDateTo, handleClearTraveler, isWidgets } = this.props;
        return (
            <Fragment>
                <Form className='fare-forecaster-form test'>
                    <div className={isWidgets ? 'SearchWidget' : 'Search'}>
                        <div style={{ maxWidth: '650px', padding: '16px 0' }}>
                            <Radio.Group value={searchParam.isTravelDate ? 1 : 2} >

                                <Radio value={1} onChange={() => {
                                    searchParam.isTravelDate = true;
                                    handleSearchParamChange(searchParam)
                                }}
                                    style={{ marginRight: '20px' }}><FormattedMessage id='travel_date_range' /></Radio>
                                <Radio value={2} onChange={() => {
                                    searchParam.isTravelDate = false;
                                    handleSearchParamChange(searchParam)
                                }} style={{ marginBottom: '0' }}><FormattedMessage id='transaction_date_range' />
                                </Radio>


                            </Radio.Group>
                        </div>

                        <div className='inv-form-inner ctm-ant-wrapper'>
                            <Form.Item>
                                <DatePicker
                                    className='date-txt__wrap'
                                    style={{ width: '100%' }}
                                    onChange={data => {
                                        searchParam.travelDateFrom = formatDate(data);
                                        handleSearchParamChange(searchParam)
                                    }
                                    }
                                    suffixIcon={<Fragment />}
                                    value={convertDate(searchParam.travelDateFrom)}
                                    format={getCurrentLang() === Languages.en_us ? 'DD MMM YYYY' : 'YYYY[年]MM[月]DD[日]'}
                                    dropdownClassName='ctm-ant-wrapper'
                                    placeholder={this.fm('select_date')}
                                ></DatePicker>
                            </Form.Item>

                            <Form.Item>
                                <DatePicker
                                    className='date-txt__wrap'
                                    style={{ width: '100%' }}
                                    format={getCurrentLang() === Languages.en_us ? 'DD MMM YYYY' : 'YYYY[年]MM[月]DD[日]'}
                                    value={convertDate(searchParam.travelDateTo)}
                                    onChange={date => {
                                        handleSearchDateTo(formatDate(date))
                                        searchParam.travelDateTo = formatDate(date);
                                        handleSearchParamChange(searchParam)
                                    }}
                                    suffixIcon={<Fragment />}
                                    disabledDate={date => this.disabledDate(searchParam.travelDateFrom, date)}
                                    dropdownClassName='ctm-ant-wrapper'
                                    placeholder={this.fm('select_date')}
                                >
                                </DatePicker>
                            </Form.Item>

                            <Form.Item style={{ display: companyDataSource.length == 1 ? "none" : "" }} >
                                {
                                    companyDataSource.length != 1 &&
                                    <AutoComplete
                                        className='cN'
                                        dropdownMatchSelectWidth={false}
                                        placeholder={<FormattedMessage id='companyName' />}
                                        value={searchParam.companyName}
                                        allowClear={true}
                                        dataSource={this.state.filterCompanyData.map((item) => {
                                            return this.renderOption(item)
                                        })}
                                        onSelect={val => {
                                            var name = companyDataSource.find(x => x.Id == val).DisplayName;
                                            searchParam.companyId = val;
                                            searchParam.travelerProfileSourceIds = [];
                                            searchParam.companyName = name;
                                            searchParam.travelerId = '';
                                            searchParam.travelerName = '';
                                            handleSearchParamChange(searchParam)
                                            handleClearTraveler()
                                        }}
                                        onSearch={val => {
                                            searchParam.companyName = val;
                                            this.setState({ filterCompanyData: companyDataSource.filter(x => x.DisplayName.startsWith(val)) })
                                            handleSearchParamChange(searchParam);
                                        }}
                                        onChange={val => {
                                            if (!val) {
                                                searchParam.companyId = '';
                                                searchParam.travelerId = '';
                                                searchParam.travelerProfileSourceIds = [];
                                                handleSearchParamChange(searchParam)
                                                handleClearTraveler()
                                            }
                                        }}
                                    ></AutoComplete>
                                }
                            </Form.Item>

                            <Form.Item>
                                <AutoComplete
                                    dropdownMatchSelectWidth={false}
                                    placeholder={<FormattedMessage id='travelerName' />}
                                    dataSource={travelDataSource.map((item) => {
                                        return this.renderTravelOption(item)
                                    })}
                                    value={searchParam.travelerName}
                                    allowClear={true}
                                    onChange={val => {
                                        if (!searchParam.companyId) {
                                            for (let inputParent of [...document.getElementsByClassName('cN')]) {
                                                let inputRequire = inputParent.getElementsByTagName('input')[0];
                                                inputRequire.click();
                                            }
                                        } else {
                                            if (!val) {
                                                searchParam.travelerProfileSourceIds = [];
                                            }
                                            searchParam.travelerName = val;
                                            handleSearchParamChange(searchParam)
                                        }

                                    }}
                                    onSearch={val => {
                                        if (searchParam.companyId) {
                                            handleSearch(val, searchParam.companyId)
                                        }
                                    }}
                                    onSelect={val => {
                                        if (searchParam.companyId) {
                                            searchParam.travelerName = travelDataSource.find(x => x.travelerId == val).travelerName;
                                            searchParam.travelerId = val;
                                            searchParam.travelerProfileSourceIds = [];
                                            searchParam.travelerProfileSourceIds.push(val);
                                            handleSearchParamChange(searchParam)
                                        }
                                    }}
                                ></AutoComplete>
                            </Form.Item>

                            <Form.Item>
                                <Input
                                    placeholder={this.fm('invoice')}
                                    value={searchParam.invoiceNo}
                                    maxLength={10}
                                    onChange={val => {
                                        searchParam.invoiceNo = val.target.value;
                                        handleSearchParamChange(searchParam)
                                    }
                                    }
                                >
                                </Input>
                            </Form.Item>
                        </div>
                        <div className='btn-wrapper'>
                            <button type="submit" className="ctm-btn ctm-tile-btn" onClick={x => handleSubmit()}><FormattedMessage id='search' /></button>
                        </div>
                    </div>
                </Form>
            </Fragment>
        )
    }
}

const CTMInvoiceForm = Form.create()(SearchForm);

export default CTMInvoiceForm;